import React, { useState } from 'react';
import { Tabs } from 'antd';
// import LeadSatusesTable from './leadsStatusTable';
import HeadingTypography from 'src/app/components/shared/Typography/Heading';
import SectionLayout from '../Section-layout-Supply';
import SectionLayoutReview from '../Section-layout-Review';
// import LeadTable from '../leadsTable';
// import LeadCredit from '../LeadCredit';

const SupplyAccountLayout: React.FC = () => {
  const [activeTab, setActiveTab] = useState('1');

  return (
    <div className="pt-6 bg-gray-100 rounded-lg w-full">
      <Tabs  defaultActiveKey="1" onChange={key => setActiveTab(key)} tabBarStyle={{ borderBottom: '1px solid #d9d9d9' }} className="text-lg font-semibold tabs-custom-style">
        <Tabs.TabPane
          key="1"
          className="p-0"
          tab={
            <>
              <HeadingTypography classNames="flex items-center h-[40px] px-[24px]" fontSize={18}>
                Supply
              </HeadingTypography>
              {activeTab === '1' && <div className="absolute bottom-[0px] z-10 left-0 w-full h-[2px] bg-[#BD273B]" />}
            </>
          }
        >
          {activeTab === '1' && (
            <>
             <SectionLayout/>
            </>
          )}
        </Tabs.TabPane>

        <Tabs.TabPane
          key="2"
          tab={
            <>
              <HeadingTypography fontSize={18} classNames="text-gray-400 text-[#DBD7D7] font-normal flex items-center h-[40px] px-[24px]">
                Review
              </HeadingTypography>
              {activeTab === '2' && <div className="absolute bottom-[0px] z-10 left-0 w-full h-[2px] bg-[#BD273B]" />}
            </>
          }
        >
          {activeTab === '2' &&  (
            <>
              <SectionLayoutReview/>
            </>
          )}
        </Tabs.TabPane>

        <Tabs.TabPane
          key="3"
          tab={
            <>
              <HeadingTypography fontSize={18} classNames="text-gray-400 text-[#DBD7D7] font-normal flex items-center h-[40px] px-[24px]">
                Accounts
              </HeadingTypography>
              {activeTab === '3' && <div className="absolute bottom-[0px] z-10 left-0 w-full h-[2px] bg-[#BD273B]" />}
            </>
          }
        >
          {activeTab === '3' && <>TBD</>}
        </Tabs.TabPane>


      </Tabs>
    </div>
  );
};

export default SupplyAccountLayout;
